module.exports = __webpack_public_path__ + "img/phone.26ad9efc.svg";